
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {isArray, isObject} from 'lodash';
import Button from '@material-ui/core/Button';
import styled from "styled-components";
import { withAsync } from './withAsync';


const StyledButton = styled(Button)`
  font-weight: normal;
  white-space: nowrap;
  margin: 0 5px 5px 0;
  
  &.active {
    background: #ccc;
  }
`;


export class SelectButtonWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    emptyValue: PropTypes.any,
  };

  static defaultProps = {
    optionLabel: 'label',
    optionValue: 'value',
    emptyValue: null
  };

  getOptionLabel = (option) => {
    return option[this.props.optionLabel];
  };

  getOptionValue = (option) => {
    return option[this.props.optionValue];
  };

  handleChange = (option) => {
    const { onChange, emptyValue } = this.props;
    if (option) {
      onChange(this.getOptionValue(option), option);
    }
    else {
      onChange(emptyValue, null);
    }
  };

  render() {
    const { value, options } = this.props;
    let selectValue = null;
    if (value !== null && value !== undefined && !isArray(value)) {
      if (isObject(value)) {
        selectValue = this.getOptionValue(value);
      }
      else {
        selectValue = value;
      }
    }

    return (
      <React.Fragment>
        {options.map((option) => (
          <StyledButton
            variant="outlined"
            key={this.getOptionValue(option)}
            onClick={() => this.handleChange(option)}
            className={this.getOptionValue(option) === selectValue ? 'active' : undefined}
          >
            {this.getOptionLabel(option)}
          </StyledButton>
        ))}
      </React.Fragment>
    );
  }
}


export const AsyncSelectButtonWidget = withAsync(SelectButtonWidget);
